import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axiosInstance from "../axiosInstance";
import AcademicSetup from "./AcademicSetup";
import CoreSettings from "./CoreSettings";
import RolesPermissions from "./RolesPermissions";
import SchoolFinanceSettings from "./SchoolFinanceSettings";
import SettingsMenu from "./SettingsMenu";
import SystemUsers from "./SystemUsers";

function Settings() {
  const [activeTab, setActiveTab] = useState("roles");
  const [permissions, setPermissions] = useState([]);
  const [roles, setRoles] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadSettings = async () => {
    try {
      setLoading(true);
      await axiosInstance.post("settings/rbac/bootstrap/");
      const [permissionsResponse, rolesResponse, usersResponse] = await Promise.all([
        axiosInstance.get("settings/permissions/"),
        axiosInstance.get("settings/roles/"),
        axiosInstance.get("settings/system-users/"),
      ]);
      setPermissions(permissionsResponse.data || []);
      setRoles(rolesResponse.data || []);
      setUsers(usersResponse.data || []);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load settings.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSettings();
  }, []);

  return (
    <div className="container-fluid py-4">
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-4">
        <div>
          <h3 className="fw-bold mb-1" style={{ color: "#125b2d" }}>Settings</h3>
          <p className="text-muted mb-0">Manage roles, users, academic setup, finance setup, security, and notifications.</p>
        </div>
        <button className="btn btn-outline-success d-flex align-items-center gap-2" onClick={loadSettings} title="Refresh settings">
          <i className="bi bi-arrow-clockwise"></i>
          <span className="d-none d-md-inline">Refresh</span>
        </button>
      </div>

      {loading && <div className="alert alert-light border"><span className="spinner-border spinner-border-sm me-2"></span>Loading settings...</div>}

      <div className="row g-4">
        <div className="col-lg-3 col-xl-2">
          <SettingsMenu activeTab={activeTab} onChange={setActiveTab} />
        </div>
        <div className="col-lg-9 col-xl-10">
          {activeTab === "roles" && <RolesPermissions permissions={permissions} roles={roles} onReload={loadSettings} />}
          {activeTab === "users" && <SystemUsers users={users} roles={roles} onReload={loadSettings} />}
          {activeTab === "academic" && <AcademicSetup />}
          {activeTab === "schoolFinance" && <SchoolFinanceSettings />}
          {activeTab === "assessment" && <CoreSettings defaultTab="assessment" />}
          {activeTab === "timetable" && <CoreSettings defaultTab="timetable" />}
          {activeTab === "security" && <CoreSettings defaultTab="security" />}
          {activeTab === "notifications" && <CoreSettings defaultTab="notifications" />}
        </div>
      </div>
    </div>
  );
}

export default Settings;
